import QueryString from "qs";
import dynamic from "next/dynamic";
import { GetServerSideProps, NextPage } from "next";

const NewsRoom = dynamic(() => import("@/Components/pages/blog"));

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59",
    );
  }
  const slug = ctx?.params?.slug as string;

  let apiRes = null;
  let apiResData = null;
  let isNew = false;
  const query = QueryString.stringify(
    {
      publicationState: "preview",
      filters: {
        slug: {
          $eq: slug,
        },
        publishedAt: {
          $null: true,
        },
      },
      populate: "deep, 6",
    },
    {
      encodeValuesOnly: false,
    },
  );
  apiRes = await fetch(`${baseUrl}articles?${decodeURIComponent(query)}`);
  apiResData = await apiRes.json();
  isNew = apiResData?.data[0]?.attributes?.design === "new";
  return {
    props: {
      apiResData,
      slug,
      isNew,
    },
  };
};

interface BlogDetailProps {
  apiResData: any;
  slug: string;
  status: number;
  isNew: boolean;
}

const NewsRooms: NextPage<BlogDetailProps> = ({ apiResData, slug }) => {
  return (
    <div id="root">
      <div className="middle-sction middle-pad">
        <NewsRoom slug={slug} data={apiResData} />
      </div>
    </div>
  );
};

export default NewsRooms;
